<template>
  <div class="mainContainer">
    <section class="blaFirstSection">
      <div class="row">
        <Header />
      </div>
    </section>

    <section class="blaPackagesSection">
      <div class="row pb-5">
        <div class="col-10 offset-1 col-md-8 offset-md-2">
          <div class="row mt-4">
            <div class="col-12">
              <div class="blaOfferTitle">Csomagajánlatok</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-md-10 offset-md-1">
              <div
                id="mmform224659"
                class="mmform"
                style="position:relative;padding-bottom:300px;height:0;overflow:hidden;max-width:100%;"
              ></div>

              <script type="application/javascript" defer>
                var uniqueId = 2246591615883274,
                  listId = 75435,
                  formId = 224659,
                  iwidth = 705,
                  mmDomain = "salesautopilot.s3.amazonaws.com",
                  secondMMDomain = "sw.marketingszoftverek.hu",
                  spancont = false,
                  secure =
                    "https:" == document.location.protocol ? true : false;
              </script>

              <script
                type="application/javascript"
                defer
                src="https://d1ursyhqs5x9h1.cloudfront.net/sw/scripts/mm-embed-iframe-1.15.min.js"
              ></script>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import Footer from '@/views/public/partials/Footer';
import Header from '@/views/public/partials/Header';

export default {
  components: {
    Header,
    Footer
  },
  data: () => ({}),

  method: () => ({})
};
</script>
